type TagsProps = {
  tags: {
    title?: string | null;
    slug?: string | null;
    id: string;
  }[];
};

export const Tags = ({ tags }: TagsProps) =>
  tags && tags.length > 0 ? (
    <div className="bg-base-100 rounded-md p-5 flex">
      <span className="text-base leading-6">Tags:</span>
      {tags.map((tag, i) => (
        <div className="ml-2" key={i}>
          {tag?.title}
          {tags.length > 1 && tags.length !== i + 1 ? ',' : null}
        </div>
      ))}
    </div>
  ) : null;
